




























































































































































import Vue from 'vue'

import { client } from '@/services/ApiClient'

export default Vue.extend({
  name: 'Employees',

  beforeRouteEnter(to, from, next) {
    // User must be logged in. Otherwise redirect to login.
    next(vm => {
      const { isLoggedIn, user } = vm.$root.$data
      const canSee = isLoggedIn && user.isAdmin
      if (!canSee) {
        vm.$router.replace({ name: 'Login' })
      }
    })
  },

  data: () => ({
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'name',
        filterable: true,
      },
      {
        text: 'Email',
        align: 'start',
        sortable: false,
        value: 'email',
      },
      {
        text: 'Admin',
        align: 'center',
        sortable: true,
        value: 'isAdmin',
      },
      {
        text: 'Actions',
        align: 'end',
        sortable: false,
        value: 'actions',
      },
    ],
    users: [] as UserDTO[],
    isLoading: true as boolean,
    hasError: false as boolean,
    search: '',
    userToEdit: { id: '-1', name: '', email: '', isAdmin: false } as Pick<
      UserDTO,
      'id' | 'name' | 'email' | 'isAdmin'
    >,
    userToMerge: { id: '-1', name: '', email: '' } as Pick<UserDTO, 'id' | 'name' | 'email'>,
    userIdToMergeWith: null as string | null,
    userEditDialog: false as boolean,
    userMergeDialog: false as boolean,
    emailRules: [
      (v: string) => !!v || 'E-mail is required',
      (v: string) => /.+@.+/.test(v) || 'E-mail must be valid',
    ],
    isSaving: false as boolean,
  }),

  computed: {
    autocompleteItems() {
      return this.users
        .filter(u => u.id !== this.userToMerge.id)
        .map(u => ({
          label: `${u.name || '--'} (${u.email || '--'})`,
          id: u.id,
        }))
    },
  },

  async created() {
    this.users = await client.allUsers()
    this.isLoading = false
  },

  methods: {
    mergeEmployee(employee: UserDTO): void {
      this.userToMerge = employee
      this.userMergeDialog = true
    },
    editEmployee(employee: UserDTO): void {
      this.userToEdit = employee
      this.userEditDialog = true
    },
    async saveMergeDialog() {
      if (!this.userIdToMergeWith) return
      this.isSaving = true
      try {
        await client.mergeUsers(this.userToMerge, { id: this.userIdToMergeWith })
        this.users = this.users.filter(u => u.id !== this.userToMerge.id)
        this.closeMergeDialog()
      } catch (e) {
        console.error(e)
        this.hasError = true
      } finally {
        this.isSaving = false
      }
    },
    closeMergeDialog() {
      this.userMergeDialog = false
      this.userToMerge = { id: '-1', name: '', email: '' }
      this.userIdToMergeWith = null
    },
    async saveEditDialog() {
      this.isSaving = true
      try {
        const updatedUser = await client.updateUser(this.userToEdit)
        this.users = this.users.map(u => (u.id === updatedUser.id ? updatedUser : u))
        this.userEditDialog = false
      } catch (e) {
        console.error(e)
        this.hasError = true
      } finally {
        this.isSaving = false
      }
    },
    closeEditDialog() {
      this.userEditDialog = false
      this.userToEdit = { id: '-1', name: '', email: '', isAdmin: false }
    },
  },
})
